import { AbstractAdornerDirective } from '@common/directives/abstract-adorner';
import { CriteriaObj } from '@common/data-models/criteria/criteria-obj';
import { Adorner } from '@common/data-models/service/adorner';
import { AssignmentRecord } from '@suite/playbook/data-models/records/assignment-record';
import { Directive, Input } from '@angular/core';
import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';

@Directive({
    selector: "[leftBorder]"
})
export class CardLeftBorderDirective extends AbstractAdornerDirective {
    private _styleProp = "background-color";
    @Input() public set styleProp(v: string) {
        this._styleProp = v;
        if (this._styleProp) {
            this.applyAdorner();
        }
    }
    public get styleProp(): string {
        return this._styleProp;
    }
    protected applyVC(vcToApply: { visibilityCriteria: CriteriaObj, adorner: Adorner }) {
        if (vcToApply && vcToApply.adorner && vcToApply.adorner.Color) {
            this.renderer.setStyle(this.el.nativeElement, this.styleProp, vcToApply.adorner.Color);
        } else {
            if (this.record instanceof AssignmentRecord) {
                let predefinded = this.predefinedAssignmentIconsMap[this.record.get(PSTFieldNames.PSTAssignmentCoverageType).toUpperCase()];
                if (predefinded) {
                    this.renderer.setStyle(this.el.nativeElement, this.styleProp, predefinded.color);
                } else {
                    this.renderer.setStyle(this.el.nativeElement, this.styleProp, "#DBDBDB");
                }
            } else {
                this.renderer.setStyle(this.el.nativeElement, this.styleProp, "#DBDBDB");
            }
        }
    }

    public findCriteria(): { visibilityCriteria: CriteriaObj, adorner: Adorner } {
        if (this.record instanceof AssignmentRecord) {
            this.locationID = this.globalTablesService.adornersIDS.AssignmentCardLeftBorder;
        } else {
            this.locationID = this.globalTablesService.adornersIDS.TopicCardLeftBorder;
        }
        return super.findCriteria();
    }
}


